import { takeLatest } from 'redux-saga/effects';
import { activatePolygon, assignTeamZips, clearPolygonOutcomes, createPolygon, deactivatePolygons, deletePolygons, getArea, getAreaBoundaries, getAreaDispositions, getAreaList, getAreas, getAreaTeamList, getAreaTeams, getPolygonPreview, getPolygonStatistics, getTeam, getTeamCells, getTeamDispositions, getTeamPins, getTeamPolygons, getTeamReps, getTeams, reassignRepsToPolygons, unassignRepsFromPolygons, unassignTeamZips, } from '../../redux';
import handleActivatePolygon from './handleActivatePolygon';
import handleAssignTeamZips from './handleAssignTeamZips';
import handleClearPolygonOutcomes from './handleClearPolygonOutcomes';
import handleCreatePolygon from './handleCreatePolygon';
import handleDeactivatePolygons from './handleDeactivatePolygons';
import handleDeletePolygons from './handleDeletePolygons';
import handleGetArea from '../../redux/sagas/handleGetArea';
import handleGetAreaBoundaries from './handleGetAreaBoundaries';
import handleGetAreaDispositions from './handleGetAreaDispositions';
import handleGetAreaList from './handleGetAreaList';
import handleGetAreas from './handleGetAreas';
import handleGetAreaTeamList from './handleGetAreaTeamList';
import handleGetAreaTeams from './handleGetAreaTeams';
import handleGetPolygonPreview from './handleGetPolygonPreview';
import handleGetPolygonStatistics from './handleGetPolygonStatistics';
import handleGetTeam from './handleGetTeam';
import handleGetTeamCells from './handleGetTeamCells';
import handleGetTeamDispositions from './handleGetTeamDispositions';
import handleGetTeamPins from './handleGetTeamPins';
import handleGetTeamPolygons from './handleGetTeamPolygons';
import handleGetTeamReps from './handleGetTeamReps';
import handleGetTeams from './handleGetTeams';
import handleReassignRepsToPolygons from './handleReassignRepsToPolygons';
import handleUnassignRepsFromPolygons from './handleUnassignRepsFromPolygons';
import handleUnassignTeamZips from './handleUnassignTeamZips';
function* watcher() {
    yield takeLatest(activatePolygon.request, handleActivatePolygon);
    yield takeLatest(assignTeamZips.request, handleAssignTeamZips);
    yield takeLatest(clearPolygonOutcomes.request, handleClearPolygonOutcomes);
    yield takeLatest(createPolygon.request, handleCreatePolygon);
    yield takeLatest(deactivatePolygons.request, handleDeactivatePolygons);
    yield takeLatest(deletePolygons.request, handleDeletePolygons);
    yield takeLatest(getArea.request, handleGetArea);
    yield takeLatest(getAreaBoundaries.request, handleGetAreaBoundaries);
    yield takeLatest(getAreaDispositions.request, handleGetAreaDispositions);
    yield takeLatest(getAreaList.request, handleGetAreaList);
    yield takeLatest(getAreas.request, handleGetAreas);
    yield takeLatest(getAreaTeamList.request, handleGetAreaTeamList);
    yield takeLatest(getAreaTeams.request, handleGetAreaTeams);
    yield takeLatest(getPolygonPreview.request, handleGetPolygonPreview);
    yield takeLatest(getPolygonStatistics.request, handleGetPolygonStatistics);
    yield takeLatest(getTeam.request, handleGetTeam);
    yield takeLatest(getTeamCells.request, handleGetTeamCells);
    yield takeLatest(getTeamDispositions.request, handleGetTeamDispositions);
    yield takeLatest(getTeamPins.request, handleGetTeamPins);
    yield takeLatest(getTeamPolygons.request, handleGetTeamPolygons);
    yield takeLatest(getTeamReps.request, handleGetTeamReps);
    yield takeLatest(getTeams.request, handleGetTeams);
    yield takeLatest(reassignRepsToPolygons.request, handleReassignRepsToPolygons);
    yield takeLatest(unassignRepsFromPolygons.request, handleUnassignRepsFromPolygons);
    yield takeLatest(unassignTeamZips.request, handleUnassignTeamZips);
}
const sagas = () => ([
    watcher(),
]);
export default sagas;
